"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const feature_flags_provider_1 = require("../feature-flags-provider");
exports.default = {
    props: {
        name: { type: String, required: true },
        class: { type: String, required: false, default: '' },
        tag: { type: String, required: false, default: 'div' }
    },
    methods: {
        isFeatureEnabled() {
            return feature_flags_provider_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled(this.name);
        },
        updateFeatureEnabledState() {
            this.featureEnabled = this.isFeatureEnabled();
        }
    },
    data() {
        return {
            featureEnabled: false
        };
    },
    async created() {
        await this.updateFeatureEnabledState();
        feature_flags_provider_1.FeatureFlagsProvider.featureFlags.on('update', this.updateFeatureEnabledState);
    },
    async destroyed() {
        feature_flags_provider_1.FeatureFlagsProvider.featureFlags.off('update', this.updateFeatureEnabledState);
    },
    render(createElement) {
        var _a;
        const props = {};
        if (this.class) {
            props.class = this.class;
        }
        if (!this.featureEnabled && !this.$slots.disabled) {
            return null;
        }
        const slotsToRender = this.featureEnabled ? ((_a = this.$slots.enabled) !== null && _a !== void 0 ? _a : this.$slots.default) : this.$slots.disabled;
        return createElement(this.tag, props, slotsToRender);
    }
};
